<template>
  <div>
    <SmartCard
      v-if="loading"
      tag="button"
      class="
        flex
        box-button
        p-3
        my-2
        user-select-none
        justify-between
        flex-col
        smart--btn-dash
      "
    >
      <SmartSkeletonLoading :items="3" :height="3" />
    </SmartCard>
    <SmartCard
      v-else
      tag="button"
      class="
        flex
        box-button
        p-3
        my-2
        user-select-none
        justify-between
        flex-col
        smart--btn-dash
      "
    >
      <div class="flex justify-start w-full" v-if="icon">
        <SmartIcon :name="icon" type="big" :size="6" :color="iconColor" />
      </div>
      <div class="smart--text-wrapper w-full">
        <SmartTitle
          heading="2"
          weight="medium"
          class="font-title text-left w-full pt-2"
        >
          {{ title }}
        </SmartTitle>
        <p class="text-black h2 font-normal text-left py-2 w-full">
          {{ description }}
        </p>
      </div>
      <div class="pt-3 border-t-default w-full mt-2">
        <SmartButton
          @click.native="action"
          quaternary
          class="w-full"
          :id="name"
        >
          {{ buttonText }}
        </SmartButton>
      </div>
    </SmartCard>
  </div>
</template>

<script>
// @flow

export default {
  name: "SmartButtonDash",
  components: {
    SmartCard: () => import("../SmartCard"),
    SmartTitle: () => import("../SmartTitle"),
    SmartButton: () => import("../SmartButton"),
    SmartIcon: () => import("../SmartIcon"),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      default: () => true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    sizeIcon: {
      type: String,
    },
    iconColor: {
      type: String,
    },
    length: {
      type: String,
    },
  },
};
</script>

<style lang="scss">
.box-button {
  box-shadow: 0px 4px 12px rgba($color-ui-black, $opacity-low-min);
  border-radius: $border-radius-default;
  transition-property: opacity, border-color, box-shadow, transform;
  transition-duration: $transition-sm-slow;
  transition-timing-function: $transition-easing-default;
  &:hover {
    opacity: 0.9;
    transform: scale(1.05);
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
  &:active,
  &:focus {
    @extend .box-button:hover;
    box-shadow: 0 2px 24px rgba($color-ui-black, $opacity-low-half);
  }
}

.smart--btn-dash {
  align-items: stretch;
}
.icon-skeleton-loading {
  width: 30px;
  height: 30px;
  border: 25px;
}
</style>
